var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E6E2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9999 13.833C17.9373 13.833 13.8333 17.9371 13.8333 22.9997C13.8333 28.0623 17.9373 32.1663 22.9999 32.1663C28.0625 32.1663 32.1666 28.0623 32.1666 22.9997C32.1666 17.9371 28.0625 13.833 22.9999 13.833ZM22.9999 18.833C22.5397 18.833 22.1666 19.2061 22.1666 19.6663C22.1666 20.1266 22.5397 20.4997 22.9999 20.4997H23.0083C23.4685 20.4997 23.8416 20.1266 23.8416 19.6663C23.8416 19.2061 23.4685 18.833 23.0083 18.833H22.9999ZM23.8333 22.9997C23.8333 22.5394 23.4602 22.1663 22.9999 22.1663C22.5397 22.1663 22.1666 22.5394 22.1666 22.9997V26.333C22.1666 26.7932 22.5397 27.1663 22.9999 27.1663C23.4602 27.1663 23.8333 26.7932 23.8333 26.333V22.9997Z",
    fill: "#6954B6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F2F1F9",
    strokeWidth: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.00a1480d3152b4769771e011af4f9eaa.svg";
export { ForwardRef as ReactComponent };